import { ChangeDetectionStrategy, Component, input, linkedSignal } from '@angular/core';

interface Alert {
  display: boolean;
  message: string;
}

@Component({
  selector: 'ui-alert-banner',
  template: `
    @for (alert of activeAlerts(); track $index; let index = $index) {
      <div class="bg-warning p-2 text-center">
        {{ alert.message }}
        <button role="button" class="float-end" (click)="dismiss(index)">Dismiss</button>
      </div>
    }
  `,
  styles: [
    `
      button {
        background: none;
        border: none;
        text-decoration: underline;
        padding: 0;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertBannerComponent {
  public readonly alerts = input<Record<string, Alert>>();

  protected activeAlerts = linkedSignal(() => {
    const alerts = this.alerts();
    return alerts ? Object.values(alerts).filter((alert) => alert.display) : [];
  });

  protected dismiss(index: number): void {
    this.activeAlerts.update((currentAlerts) => currentAlerts.filter((_, i) => i !== index));
  }
}
